import React from 'react';

import { Box, ChakraStyledOptions } from '@chakra-ui/react';
import FreeEbooks from 'images/doodles/free-ebooks.png';
import Image from 'next/image';

import { AnimateWhenInViewWrapper } from '@/components/wrappers';

export const FreeEbooksDoodle = ({ ...chakraProps }: ChakraStyledOptions) => (
  <AnimateWhenInViewWrapper variant="snap">
    <Box {...chakraProps} as={Image} src={FreeEbooks} alt="free ebooks" />
  </AnimateWhenInViewWrapper>
);
